<template>
  <div id="app">
    <NavBar v-if="!isAdminRoute" />
    <router-view />
    <FooterBar v-if="!isAdminRoute" />
    <el-backtop v-if="!isAdminRoute" :right="40" :bottom="40">
      <div class="back-top-btn">
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import FooterBar from '@/components/FooterBar.vue'

export default {
  name: 'App',
  components: { NavBar, FooterBar },
  computed: {
    isAdminRoute() {
      return this.$route.meta && this.$route.meta.admin
    }
  }
}
</script>

<style lang="less">
.back-top-btn {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0a5c8a, #00c9a7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  box-shadow: 0 4px 16px rgba(0, 201, 167, 0.35);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
}
</style>
